// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 00:01:42

export default {
  "id": "christmas-sorting",
  "slug": "christmas-sorting",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/da6c3cd607e8496f979a5aef65b8409f-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/da6c3cd607e8496f979a5aef65b8409f/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Christmas sorting",
      "description": "Christmas Sorting is a relaxing game for all ages. Place objects next to each other to collect 3 identical objects in a row.\nCollect all the unique decorations for a Christmas atmosphere.\nCreate Christmas coziness, decorate the Christmas tree the way you want.",
      "instructions": "Place objects along the portals, connect three identical objects in a row to make them disappear.\nTo complete the level, you must clear all portals of objects.\nAs you earn points, you can unlock more different avatars, portals, and backgrounds.\nUse a magic wand to remove paired items.\nUse a magnifying glass to highlight identical objects.\nAs you complete levels, get Christmas tree decorations, decorate the Christmas tree and watch how other players do it.",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "2d",
        "christmas",
        "cute",
        "logic",
        "sorting"
      ]
    },
    "zh-CN": {
      "title": "圣诞分类",
      "description": "圣诞分类是一款适合所有年龄段的轻松游戏。将物体放置在一起，收集一行三个相同的物体。\n收集所有独特的装饰，营造圣诞氛围。\n创造圣诞温馨，按照你的意愿装饰圣诞树。",
      "instructions": "在传送门处放置物体，将三行相同的物体连成一线以使其消失。\n要完成关卡，你必须清除所有传送门上的物体。\n随着你获得分数，你可以解锁更多不同的头像、传送门和背景。\n使用魔法棒移除配对的物品。\n使用放大镜突出显示相同的物体。\n完成关卡后，获得圣诞树装饰，装饰圣诞树并观看其他玩家的装饰方式。",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "2D",
        "圣诞节",
        "可爱",
        "逻辑",
        "排序"
      ]
    },
    "zh-TW": {
      "title": "聖誕節分類",
      "description": "聖誕節分類遊戲是一個適合各年齡層的輕鬆遊戲。將物體放置在一起，以收集一行3個相同的物體。\n收集所有獨特的裝飾品，營造聖誕節氣氛。\n創造聖誕節的溫馨，按照您想要的樣式裝飾聖誕樹。",
      "instructions": "將物件放置在門檻上，將三個相同的物件排成一行以使其消失。\n要完成關卡，您必須清空所有門檻上的物件。\n隨著您積累分數，您可以解鎖更多不同的化身、門檻和背景。\n使用魔法棍移除配對的物品。\n使用放大鏡突出顯示相同的物件。\n隨著您完成關卡，獲得聖誕樹裝飾品，裝飾聖誕樹並觀察其他玩家如何做。",
      "genres": [
        "休闲",
        "謎題"
      ],
      "tags": [
        "2D",
        "聖誕節",
        "可愛",
        "邏輯",
        "排序"
      ]
    },
    "zh-HK": {
      "title": "聖誕節分類",
      "description": "聖誕分類遊戲是一個適合所有年齡層的輕鬆遊戲。將物體放在一起以收集一行三個相同的物體。\n收集所有獨特的裝飾品，營造聖誕氣氛。\n創造聖誕溫馨，按你想要的樣子裝飾聖誕樹。",
      "instructions": "將物品放置於傳送門上，連成三個相同的物品使其消失。\n為了完成關卡，你必须清空所有傳送門上的物品。\n當你獲得分數時，可以解鎖更多不同的人物、傳送門和背景。\n使用魔法棒移除配對的物品。\n使用放大鏡突出顯示相同的物品。\n完成關卡後，獲得聖誕樹裝飾品，裝飾聖誕樹並觀看其他玩家如何進行裝飾。",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "2D",
        "聖誕節",
        "可愛",
        "邏輯",
        "分類"
      ]
    },
    "ja": {
      "title": "クリスマス整理",
      "description": "クリスマスソートは、全ての年齢層に適したリラックスしたゲームです。物を隣合わせに配置して、並んで3個の同じ物を集めます。\nクリスマスの雰囲気を演出するユニークな装飾を全て集めます。\nクリスマスの温かみを作り出し、好きなようにクリスマスツリーを飾り付けます。",
      "instructions": "ポータルにオブジェクトを配置し、同じオブジェクトを一列に連結して消去します。\nレベルをクリアするには、すべてのポータルからオブジェクトをクリアする必要があります。\nポイントを稼いだら、さまざまなアバター、ポータル、背景を解除できます。\n魔法の杖を使ってペアのアイテムを取り除きます。\n拡大鏡を使って同じオブジェクトをハイライトします。\nレベルをクリアすると、クリスマスツリーの装飾品を手に入れ、クリスマスツリーを飾り、他のプレイヤーの作成を観察します。",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "2D",
        "クリスマス",
        "可愛い",
        "ロジック",
        "並べ替え"
      ]
    },
    "ko": {
      "title": "クリスマスソート",
      "description": "크리스마스 정리는 모든 연령대를 위한 편안한 게임입니다. 물체를 근처에 두고 일직선에 3개의 같은 물체를 모읍니다.\n크리스마스 분위기를 만드는 독특한 장식을 모두 수집하세요.\n크리스마스 휴식을 만들고, 마음대로 크리스마스 나무를 꾸미세요.",
      "instructions": "포털에 물체를 배치하고, 세 개의 동일한 물체를 일직선으로 연결하여 사라지게 만들어주세요.\n레벨을 완료하기 위해 모든 포털의 물체를 모두 지우셔야 합니다.\n점수를 받으면 더 많은 다른 아바타, 포털, 배경을 해금할 수 있습니다.\n마법 지팡이를 사용하여 짝이 맞는 물체를 제거하세요.\n확대경을 사용하여 동일한 물체를 강조하세요.\n레벨을 완료하면 크리스마스 트리 장식을 얻고, 크리스마스 트리를 꾸며보세요. 다른 플레이어들이 어떻게 꾸며보는지 확인하세요.",
      "genres": [
        "캐주얼",
        "퍼즐"
      ],
      "tags": [
        "2D",
        "크리스마스",
        "귀여운",
        "논리",
        "정렬"
      ]
    },
    "fr": {
      "title": "Tri de Noël",
      "description": "Christmas Sorting est un jeu apaisant pour tous les âges. Placez les objets côte à côte pour rassembler 3 objets identiques en ligne.\nRassemblez toutes les décorations uniques pour créer une ambiance de Noël.\nCréez une ambiance de Noël chaleureuse, décorez l'arbre de Noël comme vous le souhaitez.",
      "instructions": "Placez des objets le long des portails, connectez trois objets identiques en ligne pour les faire disparaître.\nPour terminer le niveau, vous devez vider tous les portails d'objets.\nAu fur et à mesure que vous gagnez des points, vous pouvez déverrouiller plus d'avatars, de portails et de fonds différents.\nUtilisez une baguette magique pour supprimer des items jumelés.\nUtilisez une loupe pour mettre en évidence des objets identiques.\nAu fur et à mesure que vous terminez les niveaux, obtenez des décorations de sapin de Noël, décorez l'arbre de Noël et regardez ce que font les autres joueurs.",
      "genres": [
        "Décontracté",
        "Puzzle"
      ],
      "tags": [
        "2D",
        "Noël",
        "mignon",
        "logique",
        "tri"
      ]
    }
  }
};
